import { SLICE_TAG } from '@/constants';

import { apiSlice } from '../api-slice';
import { WholesaleAdminRequestResponseSchema } from './wholesale-admin.schema';

export const wholesaleAdminApi = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        getWholesaleAdminRequests: builder.query({
            query: (searchParams) => {
                return {
                    url: `wholesale-admin/requests`,
                    method: 'GET',
                    params: searchParams,
                };
            },
            // transformResponse: (response) => {
            //   return ExpenseResponseSchema.parse(response);
            // },
            providesTags: [SLICE_TAG.WHOLESALE_ADMIN_REQUESTS],
        }),

        getWholesaleAdminCustomers: builder.query({
            query: (searchParams) => {
                return {
                    url: `wholesale-admin/customers`,
                    method: 'GET',
                    params: searchParams,
                };
            },
            // transformResponse: (response) => {
            //   return WholesaleAdminRequestResponseSchema.parse(response);
            // },
            providesTags: [SLICE_TAG.WHOLESALE_ADMIN_CUSTOMERS],
        }),

        getWholesaleAdminRequestById: builder.query({
            query: (id) => {
                return {
                    url: `wholesale-admin/requests/${id}`,
                    method: 'GET',
                };
            },
            transformResponse: (response) => {
                return WholesaleAdminRequestResponseSchema.parse(response);
            },
            providesTags: (_result, _error, id) => [
                { type: SLICE_TAG.WHOLESALE_ADMIN_REQUESTS, id },
            ],
        }),

        rejectWholesaleAdminRequest: builder.mutation({
            query: ({ id }) => {
                return {
                    url: `wholesale-admin/requests/${id}/reject`,
                    method: 'PUT',
                };
            },
            invalidatesTags: [SLICE_TAG.WHOLESALE_ADMIN_REQUESTS],
        }),

        confirmWholesaleAdminRequest: builder.mutation({
            query: ({ id, body }) => {
                return {
                    url: `wholesale-admin/requests/${id}/confirm`,
                    method: 'PUT',
                    body,
                };
            },
            invalidatesTags: [SLICE_TAG.WHOLESALE_ADMIN_REQUESTS],
        }),

        getWholesaleCustomerById: builder.query({
            query: (id) => {
                return {
                    url: `wholesale-admin/customers/${id}`,
                    method: 'GET',
                };
            },
            // transformResponse: (response) => {
            //   return WholesaleAdminRequestResponseSchema.parse(response);
            // },
            providesTags: (_result, _error, id) => [
                { type: SLICE_TAG.WHOLESALE_ADMIN_CUSTOMERS, id },
            ],
        }),

        updateCustomerPayment: builder.mutation({
            query: ({
                customerId,
                body,
            }: {
                customerId: string;
                body: { amount: number };
            }) => {
                return {
                    url: `wholesale-admin/requests/payment/${customerId}`,
                    method: 'PUT',
                    body,
                };
            },
            invalidatesTags: [SLICE_TAG.WHOLESALE_ADMIN_CUSTOMERS],
        }),

        updateWholesaleRequest: builder.mutation({
            query: ({ id, body }) => {
                return {
                    url: `wholesale-admin/requests/${id}`,
                    method: 'PUT',
                    body,
                };
            },
            invalidatesTags: [SLICE_TAG.WHOLESALE_ADMIN_REQUESTS],
        }),
    }),
});

export const {
    useGetWholesaleAdminRequestsQuery,
    useGetWholesaleAdminCustomersQuery,
    useGetWholesaleAdminRequestByIdQuery,
    useLazyGetWholesaleAdminCustomersQuery,
    useLazyGetWholesaleAdminRequestByIdQuery,
    useLazyGetWholesaleAdminRequestsQuery,
    useRejectWholesaleAdminRequestMutation,
    useConfirmWholesaleAdminRequestMutation,
    useGetWholesaleCustomerByIdQuery,
    useLazyGetWholesaleCustomerByIdQuery,
    useUpdateCustomerPaymentMutation,

    useUpdateWholesaleRequestMutation,
} = wholesaleAdminApi;
